/**
 * Generated by orval 🍺
 * Do not edit manually.
 * qcs control-plane
 * OpenAPI spec version: 0.1.0
 */

export type KnobTier = typeof KnobTier[keyof typeof KnobTier];


export const KnobTier = {
  common: 'common',
  advanced: 'advanced',
} as const;
